import { Component, OnInit } from '@angular/core';
import {GoBaseComponent} from "../go-base.component";
import {GO_COMPONENTS} from "../../../enums/e-game-objects";
import {GO_CATEGORIES} from "../../../enums/e-game-objects";
import {DOCUMENT_TYPES} from "../../../enums/enums";
import {CollectionService} from "../../../services/collection.service";
import {paramsHelper} from "../../../helpers/params-helper";

@Component({
  selector: 'app-go-event-starter',
  templateUrl: './go-event-starter.component.html',
  styles: []
})
export class GoEventStarterComponent extends GoBaseComponent implements OnInit {

    GO_COMPONENTS = GO_COMPONENTS;
    loadedEventsList:any[] = [];
    constructor(private collectionService: CollectionService) {
        super(GO_COMPONENTS.EVENT_STARTER);
    }

    getEventLabel(e:any)
    {
        return e.codeName;
    }

    ngOnInit():void{
        this.loadEvents();
    }

    loadEvents()
    {
     // console.log(`load th`);
      const search = paramsHelper
        .search()
        .json;

      const params = paramsHelper
        .loader()
        .setEndpointApi()
        .setObjectType(DOCUMENT_TYPES.GAME_EVENT)
        .setNavParams(0, 9999)
        .setSearchParams(search);

      this.collectionService.loadChunkCached(params)
        .subscribe(
          r => {
            this.loadedEventsList = r.documents;//.concat([{_id:"", id: -1}]);
            //console.log(`th loaded ${JSON.stringify(this.loadedEventsList)}`);
            //this.updateTalkingHeadsSelects();
          });
    }

}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/go/go-event-starter/go-event-starter.component.ts